module.exports = __webpack_public_path__ + "static/media/pinterest-logo.eeb263ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinterest-logo.svg
// module id = 1696
// module chunks = 0